import { Button, ButtonProps } from "primereact/button";
import React from "react";
import styled from "styled-components";
import { concatClassnames } from "../../WSUtils/util";

export const CvpButton: React.FC<ButtonProps> = ({
  label,
  className,
  ...otherProps
}) => {
  return (
    <StyledCvpButton
      label={label}
      className={concatClassnames(["cvp-button", className])}
      {...otherProps}
    />
  );
};

export const StyledCvpButton = styled(Button)`
  &.cvp-button {
    .p-button-label {
      font-weight: 600;
      font-size: 0.875em;
    }
  }
`;
